import { createContext, useContext, useState, useEffect } from "react";
import { portalApi } from "../lib/api";

const Ctx = createContext(null);
export const usePortalAuth = () => useContext(Ctx);

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null=checking, false=guest, obj=auth

  useEffect(() => {
    const t = localStorage.getItem("vs_customer_token");
    if (!t) { setCustomer(false); return; }
    portalApi.get("/portal/me")
      .then((r) => setCustomer(r.data.customer))
      .catch(() => { localStorage.removeItem("vs_customer_token"); setCustomer(false); });
  }, []);

  const setSession = (data) => {
    localStorage.setItem("vs_customer_token", data.token);
    setCustomer(data.customer);
  };
  const logout = () => { localStorage.removeItem("vs_customer_token"); setCustomer(false); };

  return <Ctx.Provider value={{ customer, setSession, setCustomer, logout }}>{children}</Ctx.Provider>;
}
